import { render, staticRenderFns } from "./NewNavigationItems.vue?vue&type=template&id=ad18c82c&scoped=true"
import script from "./NewNavigationItems.vue?vue&type=script&lang=ts"
export * from "./NewNavigationItems.vue?vue&type=script&lang=ts"
import style0 from "./NewNavigationItems.vue?vue&type=style&index=0&id=ad18c82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad18c82c",
  null
  
)

export default component.exports